/**
 * @fileOverview Inspired by this gist
 * https://gist.github.com/StephanHoyer/91d8175507fcae8fb31a
 */
import parseGithubApiV3Response from './../lib/parseGithubApiV3Response'
import getHead from './../lib/getHead'
import getBranchAndRepositoryDetails from './../lib/getBranchAndRepositoryDetails'
import getFile from './getFile'

/**
 * Commit files to branch
 * @param {string} authToken
 * @param {string} branchId
 * @param {Array<object>} files
 * @param {string} commitMessage
 * @return {Promise}
 */
async function commitFiles(authToken, branchId, files, commitMessage){

  if (!authToken)
    throw new Error(`Invalid 'authToken' ${authToken}.`)

  if (!branchId)
    throw new Error(`Invalid 'branchId' ${branchId}.`)

  if ((files instanceof Array) == false)
    throw new Error(`Invalid 'files' ${files}.`)

  if (!commitMessage)
    throw new Error(`Invalid 'commitMessage' ${commitMessage}.`)

  // Get the repository name and owner from the branch id
  var {
    repositoryOwner: owner,
    repositoryName: repoName,
    branchName,
  } = await getBranchAndRepositoryDetails(authToken, branchId)

  var headCommit = await getHead(authToken, owner, repoName, branchName)
  var baseTree = await getTree(authToken, owner, repoName, headCommit['object']['sha'])

  var blobs = await Promise.all(files.map(file => {
    return createBlob(authToken, owner, repoName, file.text)
  }))

  var tree = await createTree(
    authToken,
    owner,
    repoName,
    files.map((file, i) => ({
      path: file.path,
      mode: '100644',
      type: 'blob',
      sha: blobs[i].sha
    })),
    baseTree['sha']
  )

  var commit = await createCommit(
    authToken,
    owner,
    repoName,
    commitMessage,
    tree['sha'],
    [ headCommit['object']['sha'] ]
  )

  var result = await updateReference(authToken, owner, repoName, branchName, commit['sha'])
  //var newBranch =

  // Get the newly committed files
  var newFiles = await Promise.all(files.map(f => getFile(authToken, branchId, f.path)))

  return newFiles

}

export default commitFiles


/**
 * @param {string} authToken
 * @param {string} owner The repository owner
 * @param {string} repo The repository name
 * @param {string} content The file content
 * @return {Promise}
 */
function createBlob(authToken, owner, repo, content){
  return fetch(`https://api.github.com/repos/${owner}/${repo}/git/blobs`, {
    headers: {
      'Accept': 'application/vnd.github.v3+json',
      'Authorization': `token ${authToken}`,
    },
    method: 'POST',
    body: JSON.stringify({
      content,
      encoding: 'utf-8',
    })
  })
  .then(parseGithubApiV3Response)
}

/**
 * Get tree
 * @param {string} authToken
 * @param {string} repoOwner
 * @param {string} repoName
 * @param {string} treeSha
 * @returns {Promise<object>}
 */
function getTree(authToken, repoOwner, repoName, treeSha){
  return fetch(`https://api.github.com/repos/${repoOwner}/${repoName}/git/trees/${treeSha}`, {
    headers: {
      'Accept': 'application/vnd.github.v3+json',
      'Authorization': `token ${authToken}`,
    },
  })
  .then(parseGithubApiV3Response)
}

/**
 * Create a tree
 * @param {string} authToken
 * @param {string} repoOwner
 * @param {string} repoName
 * @param {string} tree
 * @param {string} baseTreeSha
 * @returns {Promise<object>}
 */
function createTree(authToken, repoOwner, repoName, tree, baseTreeSha){
  return fetch(`https://api.github.com/repos/${repoOwner}/${repoName}/git/trees`, {
    method: 'POST',
    headers: {
      'Accept': 'application/vnd.github.v3+json',
      'Authorization': `token ${authToken}`,
    },
    body: JSON.stringify({
      tree,
      base_tree: baseTreeSha
    })
  })
  .then(parseGithubApiV3Response)
}

/**
 * Create a commit
 * @param {string} authToken
 * @param {string} repoOwner
 * @param {string} repoName
 * @param {string} commitMessage
 * @param {string} treeSha
 * @param {Array} parents
 * @returns {Promise<object>}
 */
function createCommit(authToken, repoOwner, repoName, commitMessage, treeSha, parents){
  return fetch(`https://api.github.com/repos/${repoOwner}/${repoName}/git/commits`, {
    method: 'POST',
    headers: {
      'Accept': 'application/vnd.github.v3+json',
      'Authorization': `token ${authToken}`,
    },
    body: JSON.stringify({
      message: commitMessage,
      tree: treeSha,
      parents,
    })
  })
  .then(parseGithubApiV3Response)
}

/**
 * Update reference
 * @param {string} authToken
 * @param {string} repoOwner
 * @param {string} repoName
 * @param {string} branchName
 * @param {string} sha
 * @returns {Promise<object>}
 */
function updateReference(authToken, repoOwner, repoName, branchName, sha){
  return fetch(`https://api.github.com/repos/${repoOwner}/${repoName}/git/refs/heads/${branchName}`, {
    method: 'PATCH',
    headers: {
      'Accept': 'application/vnd.github.v3+json',
      'Authorization': `token ${authToken}`,
    },
    body: JSON.stringify({
      sha,
    })
  })
  .then(parseGithubApiV3Response)
}



// WEBPACK FOOTER //
// ./src/data/commitFiles.js